type DataItem = Record<string, any>;

type ProcessedItem = DataItem & { percentage: number };

const getAnalitycsData = (data: DataItem[], key: string, colors: string[]): ProcessedItem[] => {
  if (!data.length || !(key in data[0])) return [];
  
  const total = data.reduce((sum, item) => sum + (item[key] || 0), 0);
  
  return data
    .map((item) => ({
      name: item.name,
	    value: item[key],
      percentage: total ? ((item[key] / total) * 100) : 100,
    }))
    .sort((a, b) => b.percentage - a.percentage).map((item, index) => ({
      ...item,
      color: item.value === 0 ? "#aeb6ce" : colors[index]
    }));
};

export default getAnalitycsData;
